export default __webpack_public_path__ + "static/opt-76850798c354098f4a3c0f3751e79305.svg";